import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import InteractiveMap from "components/InteractiveMap/InteractiveMap";
import PestInformation from "components/PestInformation/PestInformation";
import NationalReports from "components/NationalReports/NationalReports";
import Contact from "components/Contact/Contact";

import Home from "components/Home/Home";
import RegularLayout from "layouts/Regular.jsx";
import MapLayout from "layouts/Map.jsx";
import PestLayout from "layouts/PestInfo.jsx";

import ForestPestByState from "components/PestInformation/forestPestByState";
import ForestPestByRegion from "components/PestInformation/forestPestByRegion";
import ForestPestByPest from "components/PestInformation/forestPestByPest";

//**fsdp packages */
import "./assets/fsdp/js/fsdp.js";
import "./assets/fsdp/js/uswds.js";
import "./assets/fsdp/css/fsdp.css";
import "./assets/fsdp/css/styles.css";
import "./assets/fsdp/css/fpc.css";

import { datadogRum } from "@datadog/browser-rum";

datadogRum.init({
  applicationId: "794776dc-904e-4246-ae7b-2ba1cfacebd6", //generated by Datadog
  clientToken: "pub6b3d8075c396b48eab79121e09473ed7", //generated by Datadog
  site: "ddog-gov.com", //the instance where Datadog is used
  service: "fpc", //this is the name of the application as it shows up in Datadog
  env: "development", //environment where the application code is being gathered from
  version: "1", //should be the same version tag as written in the release requests and Github
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: "mask-user-input",
});

datadogRum.startSessionReplayRecording();

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/map" element={<MapLayout />}>
          <Route index element={<InteractiveMap />} />
        </Route>
        <Route path="/pest-information" element={<PestLayout />}>
          <Route index element={<PestInformation />} />
          <Route path="by-pest" element={<ForestPestByPest />} />
          <Route path="by-region" element={<ForestPestByRegion />} />
          <Route path="by-state" element={<ForestPestByState />} />
        </Route>
        <Route path="/" element={<RegularLayout />}>
          <Route index element={<Home />} />
          <Route path="national-reports" element={<NationalReports />} />
          <Route path="contact" element={<Contact />} />
          <Route path="/*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
